export const ENV = process.env.REACT_APP_ENVIRONMENT;
export const BASE_URL = process.env.REACT_APP_BASE_URL || "";
export const API_URL = process.env.REACT_APP_API_URL || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const PROJECT_NAME = process.env.REACT_APP_PROJECT_NAME || "";
export const PROJECT_JSON_SUFFIX = process.env.REACT_APP_PROJECT_JSON_PATH || "";
export const PROJECT_JSON_URL = `${JSON_URL}${PROJECT_JSON_SUFFIX}`;
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || "";
export const LANGUAGE_PATH = process.env.REACT_APP_PROJECT_PATH || "";
export const ADOBE_GAME_NAME = process.env.REACT_APP_ADOBE_GAME_NAME || "";

export const QUIZ_IMAGE_URL = `${IMAGES_URL}image/trivia/quizzes/`;
export const OPTION_IMAGE_URL = `${IMAGES_URL}image/trivia/options/`;

export const STORAGE_VERSION = 1;
export const EMAIL_REGEXP = /\S+@\S+\.\S+/;
export const USER_DOB_FORMAT = "dd/MM/yyyy";
export const USER_DOB_FORMAT_PAYLOAD = "yyyy-MM-dd";

const THOUSAND = 1000;
export const TIME_FOR_ANSWER: number = 19 * THOUSAND;
export const TIME_FOR_REVIEW_RESULT: number = 6 * THOUSAND;
export const EXTRA_TIME: number = 10 * THOUSAND;

const ALLOWED_LANGUAGES_STRING = process.env.REACT_APP_ALLOWED_LANGS || "en,es,de,fr";
export const ALLOWED_LANGUAGES = ALLOWED_LANGUAGES_STRING.split(",").map((lang) => lang.trim());

export const LANGUAGES = [
	{name: "English", code: "en"},
	{name: "Español", code: "es"},
	{name: "Deutsch", code: "de"},
	{name: "Français", code: "fr"},
	{name: "العربية", code: "ar"},
];

export const SHOW_SPONSORS = false;
export const SHOW_FOOTER_LINKS = false;
export const SHOW_SHARING = false;

export * from "./navigation";
